import EditContainer from './EditContainer';

export default EditContainer;
